var moment = require("moment");
var UTILS;

module.exports = {
  cleanDate: function (value) {
    if (!this.hasValue(value)) {
      return "";
    }

    var momentDate = moment.utc(value);
    return momentDate.format("D MMMM YYYY");
  },

  /**
   * Convert a date format and return string
   *
   * @param {String} value
   * @param {String} format
   * @return String
   *
   */
  convertDateFormat: function (value, format) {
    if (!this.hasValue(value)) {
      return "";
    }

    var momentDate = moment(value, "DD/MM/YYYY");
    return momentDate.format(format);
  },

  /**
   * Function to check a value is NOT either NULL,
   * UNDEFINED, or an empty string ('')
   * @param {Object} v
   * @return Boolean
   *
   */
  hasValue: function (v) {
    return !(v === null || v === undefined || v === "");
  },

  /**
   * Function to disable all <a/> links totally, to make them accessible,
   * by removing ability to focus on them when tabbing through sections
   * within the passed-in reference
   * (if no reference is passed-in, it is assumed to be the <body> )
   * @param {jQueryElement} [optional]
   * @return
   */
  disableAllLinks: function () {
    var $domReference =
      arguments.length && arguments[0] instanceof jQuery
        ? arguments[0]
        : $("body");

    // Fetch all links and add the 'disabled' class, then disabled a11y-wise
    this.disableLinks($domReference.find("a"));
  },
  disableLinks: function ($collection) {
    $collection.each(function () {
      if ($(this).is("a")) {
        $(this).addClass("govuk-button--disabled").attr({
          tabindex: "-1",
          role: "button",
          "aria-disabled": "true",
        });
      }
    });
  },
  enableLinks: function ($collection) {
    $collection.each(function () {
      if ($(this).is("a")) {
        $(this)
          .removeClass("govuk-button--disabled")
          .removeAttr("tabindex role")
          .attr({ "aria-disabled": "false" });
      }
    });
  },

  // Chosen.js: Clear only the selected options view
  clearSelectedOpts: function (selectElement) {
    if (!$(selectElement).hasClass("chosen-select")) {
      return;
    }

    $(selectElement).val("").trigger("chosen:updated");
  },

  // Chosen.js: Reset the 'js-option-consumers'; i.e. remove all <option> elements
  removeAllOpts: function (selectElement) {
    if (!$(selectElement).hasClass("chosen-select")) {
      return;
    }

    $(selectElement).empty().trigger("chosen:updated");
  },

  // Validator for when an ID selector is required for searching the DOM
  createIDSelectorFromString: function (str) {
    if (typeof str != "string" || str.length < 1) {
      return "";
    }

    if (str.indexOf("#") > -1) {
      return str;
    }

    return "#" + str;
  },
  /**
   * Function to make a copy of an object and simultaneously de-reference it
   * from the newly-created object
   *
   * @param {Object} obj
   * @return Object
   *
   */
  copyObject: function (obj) {
    return JSON.parse(JSON.stringify(obj));
  },

  /**
   * function to convert array data to indexed array.
   *
   * @param {Object} obj
   * @return Object
   *
   */
  arrayToIndexedObject: function (obj) {
    UTILS = this;

    function _arrToObject(arr) {
      var rv = {};
      for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
      return rv;
    }

    function _isObjOrArr(val) {
      return UTILS.isObject(val) || UTILS.isArray(val);
    }

    for (var key in obj) {
      if (_isObjOrArr(obj[key])) {
        obj[key] = JSON.parse(JSON.stringify(_arrToObject(obj[key])));
      }
    }

    return obj;
  },

  /**
   * Take a nested object and return flattened value
   * @param {Object} data
   * @param {Array} blacklist
   */
  flattenObject: function (data, blacklist) {
    UTILS = this;
    blacklist = blacklist || [];

    function _flatten(obj) {
      var output = {};
      var key;
      var childKey;
      var separator = "_"; // use of a '.' separator causes issues with JS Grid
      var flatObject;

      function _isObjOrArr(val) {
        return UTILS.isObject(val) || UTILS.isArray(val);
      }

      for (key in obj) {
        if (!obj.hasOwnProperty(key)) {
          continue;
        }

        if (blacklist.indexOf(key) > -1) {
          output[key] = obj[key];
          continue;
        }

        if (_isObjOrArr(obj[key])) {
          flatObject = _flatten(obj[key]);

          for (childKey in flatObject) {
            if (!flatObject.hasOwnProperty(childKey)) {
              continue;
            }

            output[key + separator + childKey] = flatObject[childKey];
          }
        } else {
          output[key] = obj[key];
        }
      }

      return output;
    }

    return data.map(_flatten);
  },

  /**
   * Test object isArray and return boolean
   * @param {Object} item
   * @return {Boolean}
   */
  isArray: function (item) {
    return Object.prototype.toString.call(item) === "[object Array]";
  },
  isObject: function (item) {
    return Object.prototype.toString.call(item) === "[object Object]";
  },
  isObjectLiteral: function (obj) {
    return this.isObject(obj);
  },
  isArrayLiteral: function (obj) {
    return this.isArray(obj);
  },
  isArrayOfObjects: function (o) {
    return (
      $.isArray(o) &&
      o.every(function (i) {
        return $.isPlainObject(i);
      })
    );
  },

  /**
   * Return path from url
   * @param {String} url
   */
  getPathFromUrl: function (url) {
    //chiich
    return url.split("?")[0];
  },

  /**
   * Remove ?, if present, and return decodeURIComponent from queryString
   * @param {String} queryString
   */
  getDecodedSafeQueryString: function (queryString) {
    // chiich
    if (!queryString) return undefined;


    return queryString.split("?")[1]
      ? decodeURIComponent(queryString.split("?")[1])
      : decodeURIComponent(queryString);
  },

  /**
   * Take a querystring and return a object
   * @param {String} queryString
   */
  getObjectFromQueryString: function (queryString) {
    // chiich
    if (!queryString) return undefined;

    // check for ? in queryString and remove (optional)
    // queryString = queryString.split('?')[1] ? queryString.split('?')[1] : queryString;

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split("#")[0];

      // split our query string into its component parts
      var arr = queryString.split("&");

      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split("=");

        // in case params look like: list[]=thing1&list[]=thing2
        var paramNum = undefined;
        var paramName = a[0].replace(/\[\d*\]/, function (v) {
          paramNum = v.slice(1, -1);
          return "";
        });

        // set parameter value (use 'true' if empty)
        var paramValue = typeof a[1] === "undefined" ? true : a[1];

        // (optional) keep case consistent
        //paramName = paramName.toLowerCase();
        //paramValue = paramValue.toLowerCase();

        // if parameter name already exists
        if (obj[paramName]) {
          // convert value to array (if still string)
          if (typeof obj[paramName] === "string") {
            obj[paramName] = [obj[paramName]];
          }

          // if no array index number specified...
          if (typeof paramNum === "undefined") {
            // put the value on the end of the array
            obj[paramName].push(paramValue);
          }

          // if array index number specified...
          else {
            // put the value at that index number
            obj[paramName][paramNum] = paramValue;
          }
        }

        // if param name doesn't exist yet, set it
        else {
          obj[paramName] = paramValue;
        }
      }
    }

    return obj;
  },

  serialize: function (form) {
    // Ref: https://stackoverflow.com/questions/23139876

    var data;

    if (!form || form.nodeName !== "FORM") {
      throw new Error(
        "Expected a FORM element, wrapping the elements like the data 'facets', to be passed in to this 'serialize' function",
      );
      return;
    }
    var i,
      j,
      q = [];
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
      if (form.elements[i].name === "") {
        continue;
      }
      switch (form.elements[i].nodeName) {
        case "INPUT":
          switch (form.elements[i].type) {
            case "text":
            case "hidden":
            case "password":
            case "button":
            case "reset":
            case "submit":
              if (form.elements[i].value)
                q.push(form.elements[i].name + "=" + form.elements[i].value);
              break;
            case "checkbox":
            case "radio":
              if (form.elements[i].checked) {
                q.push(form.elements[i].name + "=" + form.elements[i].value);
              }
              break;
          }
          break;
        case "file":
          break;
        case "TEXTAREA":
          if (form.elements[i].value)
            q.push(form.elements[i].name + "=" + form.elements[i].value);
          break;
        case "SELECT":
          switch (form.elements[i].type) {
            case "select-one":
              if (form.elements[i].value)
                q.push(form.elements[i].name + "=" + form.elements[i].value);
              break;
            case "select-multiple":
              for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                if (form.elements[i].options[j].selected) {
                  q.push(
                    form.elements[i].name +
                      "=" +
                      form.elements[i].options[j].value,
                  );
                }
              }
              break;
          }
          break;
        case "BUTTON":
          switch (form.elements[i].type) {
            case "reset":
            case "submit":
            case "button":
              if (form.elements[i].value)
                q.push(form.elements[i].name + "=" + form.elements[i].value);
              break;
          }
          break;
      }
    }

    data = q.reduce(function (memo, curval) {
      var key = curval.split("=")[0],
        value = curval.split("=")[1];
      if (key in memo) {
        typeof memo[key] == "string"
          ? (memo[key] = [memo[key], value])
          : memo[key].push(value);
      } else {
        memo[key] = value;
      }

      return memo;
    }, {});

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (this.isArray(data[key])) {
          var idxlen = data[key].length - 1;
          data[key] = data[key].reduce(function (memo, curval, idx, arr) {
            memo[idx] = arr[idxlen - idx];
            return memo;
          }, {});
        }
      }
    }

    return {
      data: data,
      url: $.param(data),
    };
  },

  fetchFacetsWithSetValues: function (metaFacet) {
    // Init variables...
    var $scope, $facet, facetType;
    $scope = metaFacet.filter || metaFacet.facet;
    $facet = metaFacet.facet;
    facetType = metaFacet.type || metaFacet.facet.data("facet-type");

    // @todo Unit-test to verify '$scope'

    var $filtered;
    switch (facetType) {
      case "checkbox":
        $filtered = $scope.find("input[type=checkbox]:checked");
        break;
      case "radio":
        $filtered = $scope.find("input[type=radio]:checked");
        break;
      case "text":
      case "date":
        $filtered = $scope
          .find("input[type=text], textarea")
          .filter(function () {
            return (
              $(this).val() && $(this).closest(".chosen-container").length == 0
            );
          });
        break;

      case "tag":
        $filtered = $scope.find("select.chosen-select").filter(function () {
          return $(this).find(":selected").length;
        });
        break;

      default:
        $filtered = undefined;
        break;
    }

    return $filtered;
  },

  FACET_REGISTRY: {},

  addFacetToRegistry: function (facet) {
    this.FACET_REGISTRY[facet.id] = facet;
  },

  getFacetRegistry: function () {
    return this.copyObject(this.FACET_REGISTRY);
  },

  generateFacetId: function ($facet) {
    return $facet.find("legend").text().split(" ").join("_");
  },
};
